import { ValueUpdater } from '../../../../valueUpdater';
export class SchedulingInformationV11 {
    constructor() {
        this.receptionStart = null;
        this.receptionEnd = null;
        this.returnStart = null;
        this.returnEnd = null;
    }
    static constructFromPlainObject(source) {
        const instance = new SchedulingInformationV11();
        instance.receptionStart = ValueUpdater.updateNullableDateFromString(instance.receptionStart, source === null || source === void 0 ? void 0 : source.receptionStart);
        instance.receptionEnd = ValueUpdater.updateNullableDateFromString(instance.receptionEnd, source === null || source === void 0 ? void 0 : source.receptionEnd);
        instance.returnStart = ValueUpdater.updateNullableDateFromString(instance.returnStart, source === null || source === void 0 ? void 0 : source.returnStart);
        instance.returnEnd = ValueUpdater.updateNullableDateFromString(instance.returnEnd, source === null || source === void 0 ? void 0 : source.returnEnd);
        return instance;
    }
    getReceptionStart() {
        return this.receptionStart;
    }
    getReceptionEnd() {
        return this.receptionEnd;
    }
    getReturnStart() {
        return this.returnStart;
    }
    getReturnEnd() {
        return this.returnEnd;
    }
    setReceptionStart(receptionStart) {
        this.receptionStart = receptionStart;
    }
    setReceptionEnd(receptionEnd) {
        this.receptionEnd = receptionEnd;
    }
    setReturnStart(returnStart) {
        this.returnStart = returnStart;
    }
    setReturnEnd(returnEnd) {
        this.returnEnd = returnEnd;
    }
}
//# sourceMappingURL=schedulingInformationV11.js.map